import { Flex, StyleProps } from '@chakra-ui/react';
import { BPC_CARD_WIDTH } from 'common/common.constants';
import { Championnat } from '../championnat.types';
import ChampionnatPersonnaliseCard from './ChampionnatPersonnaliseCard';

export default function ChampionnatPersonnaliseList({
  championnats,
  flexWrap,
  ...styleProps
}: { championnats: Championnat[] } & StyleProps) {
  const mustWrap = flexWrap === 'wrap';
  return (
    <Flex
      display={!mustWrap ? undefined : { base: 'block', md: 'flex' }}
      {...styleProps}
    >
      {championnats
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((championnat) => (
          <ChampionnatPersonnaliseCard
            key={championnat.id}
            championnat={championnat}
            border="1px"
            borderColor="gray.200"
            minWidth={
              !mustWrap ? BPC_CARD_WIDTH : { base: 'unset', md: BPC_CARD_WIDTH }
            }
            maxWidth={
              !mustWrap ? BPC_CARD_WIDTH : { base: 'unset', md: BPC_CARD_WIDTH }
            }
            m={4}
          />
        ))}
    </Flex>
  );
}
